module.exports = __webpack_public_path__ + "static/media/Brimamanso.d7f7bc2b.jpg";